import { Icon } from 'shared/iconpack'

import { ClientHeaderInfo } from 'modules/Clients/types'

import SkeletonNode from 'shared/ui/SkeletonNode'

import { palette } from 'shared/config/styles/palette'

interface Props {
  clientDetail: ClientHeaderInfo | null
  isFetching: boolean
}

const ClientDetailHeader = ({ clientDetail, isFetching }: Props) => {
  return (
    <div className="flex gap-[12px] justify-between p-[16px] rounded-[16px] border border-light_gray_3">
      <div className="flex gap-[12px] items-center">
        <div className="p-[14px] bg-green bg-gradient-to-tr from-white/30 to-transparent rounded-full">
          <Icon
            name="time"
            size={20}
            color={palette.white}
          />
        </div>
        <div className="flex flex-col gap-[4px]">
          <span className="text-light_gray_4 leading-[20px] text-[14px]">
            Статус лояльности
          </span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-32"
          >
            <span className="leading-[24px] text-[16px] text-dark">
              {clientDetail?.loyal_status ?? 'Неизвестно'}
            </span>
          </SkeletonNode>
        </div>
      </div>
      <div className="flex gap-[12px] items-center">
        <div className="p-[14px] bg-red bg-gradient-to-tr from-white/30 to-transparent rounded-full">
          <Icon
            name="time"
            size={20}
            color={palette.white}
          />
        </div>
        <div className="flex flex-col gap-[4px]">
          <span className="text-light_gray_4 leading-[20px] text-[14px]">
            Кол-во бонусов
          </span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-28"
          >
            <span className="leading-[24px] text-[16px] text-dark">
              {clientDetail?.bonuses ?? 'Неизвестно'}
            </span>
          </SkeletonNode>
        </div>
      </div>
      <div className="flex gap-[12px] items-center">
        <div className="p-[14px] bg-dark_blue_1 bg-gradient-to-tr from-white/30 to-transparent rounded-full">
          <Icon
            name="cashUser"
            size={20}
            color={palette.white}
          />
        </div>
        <div className="flex flex-col gap-[4px]">
          <span className="text-light_gray_4 leading-[20px] text-[14px]">
            Кол-во заказов
          </span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-28"
          >
            <span className="leading-[24px] text-[16px] text-dark">
              {clientDetail?.orders_count ?? 'Неизвестно'}
            </span>
          </SkeletonNode>
        </div>
      </div>
      <div className="flex gap-[12px] items-center">
        <div className="p-[14px] bg-pink_2 bg-gradient-to-tr from-white/30 to-transparent rounded-full">
          <Icon
            name="telephone"
            size={20}
            color={palette.white}
          />
        </div>
        <div className="flex flex-col gap-[4px]">
          <span className="text-light_gray_4 leading-[20px] text-[14px]">
            Общая сумма заказов
          </span>
          <SkeletonNode
            loading={isFetching}
            className="!h-6 !w-full !max-w-36"
          >
            <span className="leading-[24px] text-[16px] text-dark">
              {clientDetail?.total_amount ?? 'Неизвестно'}
            </span>
          </SkeletonNode>
        </div>
      </div>
    </div>
  )
}

export default ClientDetailHeader
